import { constant } from "./constants";
import { l_storage, s_storage } from "./storage";


export const getTokens = () => ({
  AccessToken: l_storage.get(constant.ACCESS_TOKEN),
  RefreshToken: l_storage.get(constant.REFRESH_TOKEN),
});

export const hasTokens = () => {
  const { AccessToken, RefreshToken } = getTokens();

  return Boolean(AccessToken && RefreshToken);
};

export const setTokens = ({ AccessToken, RefreshToken }: any) => {
  if (AccessToken) l_storage.set(constant.ACCESS_TOKEN, AccessToken);
  if (RefreshToken) l_storage.set(constant.REFRESH_TOKEN, RefreshToken);
};

export const setTabSession = () => {
  if (!s_storage.get(constant.SELECTED_LEGAL_ENTITY)) {
    const legalentity = l_storage.get(constant.SELECTED_LEGAL_ENTITY);
    const languageno = l_storage.get(constant.SELECTED_LANGUAGE_NO);

    s_storage.set(constant.SELECTED_LEGAL_ENTITY, legalentity);
    s_storage.set(constant.SELECTED_LANGUAGE_NO, languageno);

    let position = "LTR";
    if (languageno.isEqual("AR"))
      position = "RTL";

    s_storage.set(constant.LAYOUT, position);
  }
};

export const setCompanyDetails = ({ timezone, selectedLegalEntity, selectedLang }: any) => {
  l_storage.set(constant.TIME_ZONE, timezone);
  l_storage.set(constant.SELECTED_LEGAL_ENTITY, selectedLegalEntity);
  l_storage.set(constant.SELECTED_LANGUAGE_NO, selectedLang);

  s_storage.clear();
  setTabSession();
};

export const getCompanyDetails = () => ({
  timezone: l_storage.get(constant.TIME_ZONE),
  selectedLegalEntity: s_storage.get(constant.SELECTED_LEGAL_ENTITY) || l_storage.get(constant.SELECTED_LEGAL_ENTITY),
  selectedLang: s_storage.get(constant.SELECTED_LANGUAGE_NO) || l_storage.get(constant.SELECTED_LANGUAGE_NO)
});

export const getLayout = () => s_storage.get(constant.LAYOUT);